import GurudevJourney from "../components/pages/GurudevJourney";

export default GurudevJourney;
